import { createFileRoute, Navigate, useLocation } from '@tanstack/react-router';
import ViewUsers from '@/features/admin/components/administration/ViewUsersList';
import { useAuth } from '@/features/auth/providers/AuthProvider';

export const Route = createFileRoute('/admin/users/')({
  component: RouteComponent,
});

function RouteComponent() {
  const { user, loading: authLoading, roleReady } = useAuth();
  const location = useLocation();

  if (authLoading || !roleReady) return null;

  if (!user) {
    return <Navigate to="/login" search={{ from: location.pathname }} replace />;
  }

  // Office managers belong on the office list. Everyone else was already sent home.
  if (user.role !== 'admin') {
    return <Navigate to={user.role === 'officeManager' ? '/admin/offices' : '/'} replace />;
  }

  return <ViewUsers />;
}
